import { primary_color } from '../../../Helper/uiHelper'
import RenderFields from '../../../CMSComponent/Forms/renderFields'
import { AvForm } from 'availity-reactstrap-validation'
import { useEffect, useState } from 'react'
import { isNumeric } from '../../../helper'
import { useDispatch, useSelector } from 'react-redux'
import { request } from '../../../Redux/Sagas/requests/api'
import { setNotification } from '../../../Redux/Reducers/notificationHandling'
import { fetchUpdateApiData } from '../../../Redux/Reducers/CMS'
import { Input, Label } from 'reactstrap'

const AddRefund = ({ addDataDetail, addFormList, onCancel }) => {
  const currentRow = useSelector((state) => state.CMS.currentRow)
  const [balance, setBalance] = useState()
  const dispatch = useDispatch()

  const [error, setError] = useState()
  const [isRaising, setIsRaising] = useState(false)
  const [units, setUnits] = useState([])
  const [markLostLockers, setMarkLostLockers] = useState(false)
  const [selectedLostUnitIds, setSelectedLostUnitIds] = useState([])

  const showError = (message) => {
    setError(message)
    setTimeout(() => {
      setError()
    }, 5000)
  }

  useEffect(() => {
    request('get-payment-detail-by-id', 'POST', { id: currentRow?.[0]?.id }).then((res) => {
      if (res?.status === 200 || res?.status === 202) {
        setBalance(parseFloat(res?.data?.data).toFixed(2))
        setUnits(Array.isArray(res?.data?.units) ? res.data.units : [])
      } else {
        dispatch(setNotification({ type: 'error', message: 'Something went wrong' }))
        onCancel()
      }
    })

    return () => {
      onCancel()
    }
  }, [])

  const toggleLostUnit = (unitId) => {
    setSelectedLostUnitIds((prev) => {
      if (prev.includes(unitId)) {
        return prev.filter((id) => id !== unitId)
      }
      return [...prev, unitId]
    })
  }

  const onRaiseRequest = (values) => {
    let payload = {
      ...values,
      payment_id: currentRow?.[0]?.id,
      base_url: window.location.origin,
      mark_lost_lockers: markLostLockers,
      lost_unit_ids: markLostLockers ? selectedLostUnitIds : [],
    }
    setIsRaising(true)
    request('add-transaction-log', 'POST', payload).then((res) => {
      if (res?.status === 200 || res?.status === 202) {
        dispatch(setNotification({ type: 'success', message: 'Refund request raised' }))
        dispatch(fetchUpdateApiData())
        onCancel()
      } else {
        dispatch(setNotification({ type: 'error', message: res?.data?.message || 'Something went wrong' }))
      }
      setIsRaising(false)
    })
  }

  const handleValidation = (values) => {
    if (!values?.type) {
      showError('Type is required')
      return
    }
    if (!values?.amount) {
      dispatch(setNotification({ type: 'error', message: 'Refund amount can not be 0' }))
      return
    }
    if (!isNumeric(parseInt(values?.amount))) {
      showError('Amount should be number')
      return
    }
    if (parseFloat(balance) < parseFloat(values?.amount)) {
      showError('Refund amount is more than paid amount')
      return
    }
    if (markLostLockers && selectedLostUnitIds.length === 0) {
      showError('Select at least one locker to mark as Lost')
      return
    }
    onRaiseRequest(values)
  }

  const selectableUnits = units.filter((unit) => String(unit?.locker_status || '').toLowerCase() !== 'lost')

  return (
    <div className='mt-4 p-5'>
      <div className='h5 mb-5 font-weight-bold' style={{ color: primary_color }}>
        Send Refund Request
      </div>
      <div className='p-3 rounded d-flex  flex-column align-items-center' style={{ background: `${primary_color}33`, width: 'fit-content' }}>
        <div className='body2 font-weight-bold' style={{ color: primary_color }}>
          Available Amount
        </div>
        <div className='h4 font-weight-bold' style={{ color: primary_color }}>
          £{balance}
        </div>
      </div>

      <AvForm
        onValidSubmit={(e, values) => {
          handleValidation(values)
        }}
        style={{ marginBottom: '1rem', maxWidth: '50rem' }}
        className='mt-4'>
        <RenderFields allForm={addFormList} content={addDataDetail?.currentTabData} />

        <div className='mt-4'>
          <Label className='d-flex align-items-center' style={{ gap: '0.5rem', cursor: 'pointer' }}>
            <Input
              type='checkbox'
              checked={markLostLockers}
              onChange={(e) => {
                const checked = e.target.checked
                setMarkLostLockers(checked)
                if (!checked) {
                  setSelectedLostUnitIds([])
                }
              }}
            />
            <span className='font-weight-bold' style={{ color: primary_color }}>
              Lost locker
            </span>
          </Label>
          <div className='text-muted small mt-1'>Selected lockers will be marked Lost only after this refund request is approved.</div>
        </div>

        {markLostLockers && (
          <div className='mt-3 p-3 rounded' style={{ background: '#f8f9fa' }}>
            <div className='font-weight-bold mb-2'>Select lockers</div>
            {selectableUnits.length === 0 ? (
              <div className='text-muted'>No lockers available to mark Lost on this booking.</div>
            ) : (
              selectableUnits.map((unit) => (
                <Label key={unit.id} className='d-flex align-items-start mb-2' style={{ gap: '0.5rem', cursor: 'pointer' }}>
                  <Input type='checkbox' checked={selectedLostUnitIds.includes(unit.id)} onChange={() => toggleLostUnit(unit.id)} />
                  <span>
                    Locker {unit.item_name}
                    {unit.location_name ? ` — ${unit.location_name}` : ''}
                    {unit.student_name ? ` (${unit.student_name.trim()})` : ''}
                    {unit.locker_status ? ` · ${unit.locker_status}` : ''}
                  </span>
                </Label>
              ))
            )}
          </div>
        )}

        {error && (
          <div className='alert alert-danger my-4' role='alert'>
            {error}
          </div>
        )}
        <div className='my-5 d-flex justify-content-end'>
          <button
            className='btn rounded-pill mt-2 text-danger border-danger mr-3'
            type='button'
            onClick={(e) => {
              onCancel()
              e.preventDefault()
              e.stopPropagation()
            }}
            style={{ fontWeight: 700, width: '8rem' }}>
            Cancel
          </button>
          <button
            className='btn text-white rounded-pill mt-2'
            disabled={!!error || isRaising}
            type='submit'
            style={{ background: primary_color, fontWeight: 700, width: '8rem' }}>
            {isRaising ? 'Saving...' : 'Save'}
          </button>
        </div>
      </AvForm>
    </div>
  )
}

export default AddRefund
